import { BareProperty, Property } from '../types/property';

import { Brand, HourFormat } from '../types/brand';

export const DEFAULT_DAY_START = { hour: 6, minute: 0 };
export const RUNDOWN_DEFAULT_FONT_SIZE = { min: 5, max: 18 };
export const RUNDOWN_LIMIT_FONT_SIZE = { min: 0, max: 48 };


export function populate(bareProperty: BareProperty, brand: Brand): Property {
  return {
    ...bareProperty,
    brand,
  };
}

export function bare(property: Property): BareProperty {
  return {
    ...property,
    brand: property.brand._id,
  };
}

export function getHourFormat(property: Property): HourFormat {
  return property?.settings?.hourFormat ?? property?.brand.hourFormat;
}

export function getMinRundownFont(property: Property): number {
  return  property?.brand?.fontSize?.min ?? RUNDOWN_DEFAULT_FONT_SIZE.min;
}

export function getMaxRundownFont(property: Property): number {
  return  property?.brand?.fontSize?.max ?? RUNDOWN_DEFAULT_FONT_SIZE.max;
}
